import Aspects from "./aspects";
const scaleOut = function (elem) {
    if (elem) {
        elem.classList.add("scale-hide");
        const tm = setTimeout(() => {
            elem.classList.add("hidden");
            clearTimeout(tm);
        }, 100);
    }
};

const scaleIn = function (elem) {
    if (elem) {
        elem.classList.remove("hidden");
        const tm = setTimeout(() => {
            elem.classList.remove("scale-hide");
            clearTimeout(tm);
        }, 100);
    }
};

window.BUILDER_BODY = {
    update() {
        this.initModals();
        Aspects.init();
        //   this.initTabs();
        //   this.initSwiper();
        //   this.initLightBox();
        //   this.initFilterableBlock();
        // //   this.initTippy();
        //   this.initColors();
        //   this.initModals();
    },
    initModals() {

        Array.from(document.querySelectorAll('.f-modal')).forEach(toggle => {
            toggle.addEventListener("click", e => {
                if (e.target === e.currentTarget){
                    document.body.classList.remove('noscroll');
                    e.currentTarget.classList.remove('show');
                }
            });
        });
    }
    // initFilterableBlock() {
    //     Array.from(document.querySelectorAll(".dn-filterable")).forEach(
    //         block => {
    //             const links = block.querySelectorAll("[data-filter]");
    //             const items = block.querySelectorAll("[data-group]");
    //             Array.from(links).forEach(link => {
    //                 link.addEventListener("click", e => {
    //                     let value = e.target.dataset.filter;
    //                     block.querySelector("[data-filter].active").classList.remove('active');
    //                     link.classList.add('active');
    //                     Array.from(items).forEach(item => {
    //                         if (value== "null") return;
    //                         if (
    //                             value == item.getAttribute("data-group") ||
    //                             value == "all"
    //                         ) {
    //                             scaleIn(item);
    //                         } else {
    //                             scaleOut(item);
    //                         }
    //                     });
    //                 });
    //             });
    //         }
    //     )
    // },
    // initLightBox() {
    //     const lightbox = GLightbox({
    //         selector: '.glightbox',
    //         touchNavigation: true,
    //         loop: true,
    //         autoplayVideos: true
    //     });
    // },
    // initSwiper() {
    //     Array.from(document.getElementsByClassName("dn-carousel")).forEach(item => {
    //         let swiperOptions = {
    //             slidesPerView: 1,
    //             spaceBetween: 25,
    //             freeMode: true,
    //             cssMode: false,
    //             observer: true,
    //             setWrapperSize: false,
    //             initialSlide: 0,
    //             navigation: {
    //                 nextEl: ".slider-nav--next",
    //                 prevEl: ".slider-nav--prev",
    //                 disabledClass: "slider-nav--hidden"
    //             },
    //             breakpoints: {
    //                 320: {
    //                     slidesPerView: 1
    //                 },
    //                 480: {
    //                     slidesPerView: 2
    //                 },
    //                 640: {
    //                     slidesPerView: 3
    //                 },
    //                 1024: {
    //                     slidesPerView: 4
    //                 },
    //                 1200: {
    //                     slidesPerView: 5
    //                 },
    //                 1640: {
    //                     slidesPerView: 6
    //                 }
    //             }
    //         };
    //         const customSwiperOptions = item.getAttribute("data-swiper-options");
    //         if (customSwiperOptions) {
    //             swiperOptions = Object.assign(
    //                 swiperOptions,
    //                 JSON.parse(customSwiperOptions),
    //             );
    //         }

    //         new Swiper(item, swiperOptions);
    //     });
    // },
    // initTabs() {
    //     Array.from(document.querySelectorAll(".block-tabs")).forEach(
    //         function(block) {
    //             const tabs = block.querySelectorAll(".tab-item");
    //             const links = block.querySelectorAll(".tab-link");
    //             links.forEach(function(link, index) {
    //                 link.addEventListener("click", function(e) {
    //                     e.preventDefault();
    //                     const activeLink = block.querySelector(
    //                         ".tab-link.active"
    //                     );
    //                     const activeTab = block.querySelector(
    //                         ".tab-item.active"
    //                     );
    //                     if (activeLink) activeLink.classList.remove("active");
    //                     if (activeTab) activeTab.classList.remove("active");
    //                     e.currentTarget.classList.add("active");
    //                     tabs[index].classList.add("active");
    //                 });
    //             });
    //         }
    //     );
    // },
    // initColors() {
    //     Array.from(document.querySelectorAll(".block-colors")).forEach(
    //         function(block) {
    //             const links = block.querySelectorAll("[data-image]");
    //             const plaeholder = block.querySelector(".placeholder");
    //             const name = block.querySelector(".color-name");
    //             links.forEach(function(link, index) {
    //                 link.addEventListener("click", function(e) {
    //                     e.preventDefault();
    //                     const activeLink = block.querySelector("[data-image].active");
    //                     if (activeLink) activeLink.classList.remove("active");
    //                     e.currentTarget.classList.add("active");
    //                     plaeholder.setAttribute("src", e.currentTarget.dataset.image);
    //                     name.innerHTML = e.currentTarget.dataset.name;
    //                 });
    //             });
    //         }
    //     );
    // },
    // initModals() {
    //     Array.from(document.querySelectorAll("[data-modal]")).forEach(
    //         function(item) {
    //             const modalId = item.dataset.modal;
    //             item.addEventListener("click", function(e) {
    //                 e.preventDefault();
    //                 document.getElementById(modalId).classList.add('active');
    //             });
    //         }
    //     );
    // },
    // initTippy() {
    //     tippy('[data-tippy-content]', {
    //         animation: 'scale',
    //         placement: 'bottom',
    //         inertia: true,
    //     });
    // }
};

document.addEventListener('DOMContentLoaded', function () {
    BUILDER_BODY.update();
})
